import React from 'react';
import styles from './inputs.module.scss';
import { AInput } from './AInput';
import _ from 'lodash';

export class MyNumberInput extends AInput {
  constructor(props) {
    super(props);
    this.state = {
      data: this.props.data,
      displayValue: String(this.props.data.value ?? "")
    };
  }

  min() {
    const expr = this.state.data.min;
    if (!expr || typeof (expr) === 'number') {
      return expr;
    }
    const p = this.getMathParser();
    return p.evaluate(expr);
  }

  max() {
    const expr = this.state.data.max;
    if (!expr || typeof (expr) === 'number') {
      return expr;
    }
    const p = this.getMathParser();
    return p.evaluate(expr);
  }

  randomize() {
    const min = this.min();
    const max = this.max() ?? 1000;

    if (!this.state.data.randomize) {
      return;
    }
    const expr = this.state.data.randomize;
    let val = 0;
    if (typeof (expr) === 'boolean') {
      val = this.generateRandomNumber(min, max)
    } else {
      const p = this.getMathParser();
      val = p.evaluate(this.state.data.randomize);
    }
    const data = this.state.data;
    data.value = _.clamp(val, min, max);
    this.setState({ data }, () => {
      if (this.props.onUpdate) {
        this.props.onUpdate();
      }
    });
  }

  validate() {
    const min = this.min();
    const max = this.max() ?? Number.MAX_SAFE_INTEGER;

    const validateExpr = this.state.data.validate;
    if (!validateExpr) {
      return true;
    }

    const val = this.state.data.value;
    const scope = { val, min, max };
    try {
      const parser = this.getMathParser(scope);
      return parser.evaluate(validateExpr, scope);
    } catch (error) {
      return false;
    }
  }

  onValueChange(ev) {
    const raw = ev.target.value;

    this.setState({ displayValue: raw });
  }

  onBlurHandler() {
    const min = this.min();
    const max = this.max() ?? Number.MAX_SAFE_INTEGER;

    const { displayValue } = this.state;
    const data = this.state.data;

    let v = parseInt(displayValue, 10);

    if (Number.isNaN(v)) {
      v = this.min();
    }

    v = _.clamp(v, min, max);

    data.value = v;
    this.setState({ data, displayValue: String(v) }, () => {
      this.props.onUpdate?.();
    });
  }

  updateDataValue(val) {
    const data = this.state.data;
    data.value = val;
    this.setState({ data, displayValue: String(val) }, () => {
      this.props.onUpdate?.();
    });
  }

  increment() {
    const min = this.min();
    const max = this.max() ?? Number.MAX_SAFE_INTEGER;

    let v = parseInt(this.state.data.value, 10);

    if (isNaN(v)) {
      v = this.min();
    } else {
      v = _.clamp(v + 1, min, max);
    }

    this.updateDataValue(v);
  }

  decrement() {
    const min = this.min();
    const max = this.max() ?? Number.MAX_SAFE_INTEGER;

    let v = parseInt(this.state.data.value, 10);

    if (isNaN(v)) {
      v = this.min();
    } else {
      v = _.clamp(v - 1, min, max);
    }

    this.updateDataValue(v);
  }

  renderInput() {
    const min = this.min();
    const max = this.max();
    const isValid = this.validate();

    return (
      <div className={styles.myNumberInput}>
        <button type="button" onClick={this.decrement.bind(this)} className={styles.btn}>
          –
        </button>
        <input
          type="text"
          inputMode="numeric"
          pattern="[0-9]*"
          min={min}
          max={max}
          value={this.state.displayValue}
          onChange={this.onValueChange.bind(this)}
          onBlur={this.onBlurHandler.bind(this)}
          className={isValid ? "" : styles.error}
        />
        <button type="button" onClick={this.increment.bind(this)} className={styles.btn}>
          +
        </button>
      </div>
    );
  }
}